import cn from 'classnames';

import Icon from 'components/icon/Icon';

export const shapeTypes = {
  rectangle: 'rectangle',
  circle: 'circle',
  snakeH: 'snake-horizontal',
  snakeV: 'snake-vertical',
  longH: 'long-horizontal',
  longV: 'long-vertical'
} as const;

export const shapeColors = {
  orange: '#ffb74c',
  red: '#ff6d55',
  teal: '#6ed5e4',
  purple: '#26266d',
  green: '#00b982',
  pink: '#b35da9'
} as const;

export type ShapeType = keyof typeof shapeTypes;
export type ShapeColor = (typeof shapeColors)[keyof typeof shapeColors];

interface ShapeProps {
  type: ShapeType;
  color: ShapeColor;
  className?: string;
}

const Shape: React.FC<ShapeProps> = ({ type, color, className }) => {
  return <Icon className={cn('shape', className)} style={{ color }} name={`np-${shapeTypes[type]}`} fill />;
};

Shape.displayName = 'Shape';

export default Shape;
